import SessaoDigitar from '../../views/Digitacao/SessaoDigitar';
import SessaoRevisar from '../../views/Digitacao/SessaoRevisar';
import { __ADMINISTRADOR, __APOIO_SECRETARIAL, __CENTRAL, __COORDENADOR, __DIGITADOR } from '../../security/RoleConfiguration';

export const path = '/admin/digitacao';

export const listRoutes = [
    {
        path: `${path}/digitar`,
        component: SessaoDigitar,
        roles: [ __ADMINISTRADOR, __CENTRAL, __COORDENADOR, __APOIO_SECRETARIAL, __DIGITADOR ],
    },
    {
        path: `${path}/revisar`,
        component: SessaoRevisar,
        roles: [ __ADMINISTRADOR, __CENTRAL ],
    },
]

export default listRoutes;
